import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import HeaderView from "../../components/admin/headerView";
import { APP_CONFIG } from "../../constants/constants";
import { routeUrls } from "../../navigation/routeUrls";
import MessagingMainSection from './messagingMainSection';

const ScreenChat = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'chatSection' });
  const navigate = useNavigate();

  return (
    <>
      <HeaderView
        title={t("heading")}
        showBackButton={true}
        backButtonCallback={() => navigate(routeUrls.dashboard)}
      />
      <div className={`${APP_CONFIG.DES.DASH.P_HORIZ} my-2 max-h-[calc(100vh-160px)] overflow-y-auto`}>
        <>
          {/* Moved PubNub Provider to dashboardWrapper.tsx */}
          <MessagingMainSection />
        </>
      </div>
    </>
  )
}
export default ScreenChat;